import { Component, h } from '@stencil/core';

/**
 * @description A content area with a patterned background.
 * @use
 * @since 4.0.0
 * @slot - `default slot`: The inserted content to be displayed.
 * @version 3
 */
@Component({
  tag: 'hp6-background',
  styleUrl: 'background.scss',
  shadow: false, // Already satisfies the single-tag policy without shadow DOM
})
export class Background {
  render() {
    return <slot />;
  }
}
